import { OPERATION } from "../../actions/actionConstants.js";
import {
  getOperation,
  buildOperationOptions
} from "../../../utils/operations.js";
import { getActionEntityByType } from "../../../utils/utils.js";

// @param options object as follows
// {
//   showErrorModal = true,
//   isFatal = false,
//   autoComplete = true,
//   success = undefined,
//   fail = undefined
// }

export const operationActionByEntity = (
  entity,
  operarationName,
  data,
  options
) => {
  if (!entity) return null;

  const actionEntity = getActionEntityByType(entity["@type"]);

  if (!actionEntity) return null;

  return operationAction(actionEntity, entity, operarationName, data, options);
};

export const operationActionByType = (
  type,
  entity,
  operationName,
  data,
  options
) => {
  const actionEntity = getActionEntityByType(type);

  if (!actionEntity) return null;

  return operationAction(actionEntity, entity, operationName, data, options);
};

export const operationAction = (
  actionEntity,
  entity,
  operationName,
  data = {},
  options = {}
) => {
  if (!entity) return null;

  // retrieve operation object from entity
  const operation = getOperation(
    operationName,
    entity.operations,
    entity.enabledOperations
  );

  // reject action if there is no operation object available
  if (!operation) {
    const error = `WARNING: Invalid action name supplied - Associated object could not be found on entity.`;
    console.error(error);
    return { type: "internal-error", payload: { error } };
  }

  let originalData = {};

  if (operation.fields) {
    originalData = operation.fields.reduce((acc, item) => {
      acc[item.name] = item.value;
      return acc;
    }, {});
  }

  // construct updated operation fields object
  const payload = {
    ...operation,
    fields: { ...originalData, ...data },
    fieldPath: data.fieldPath || undefined
  };

  const { success, fail } = options;

  const operationOptions = buildOperationOptions(options);

  const result = {
    type: OPERATION,
    actions: {
      operation: {
        type: actionEntity[operation.method],
        actionEntity,
        payload,
        options: operationOptions
      },
      success,
      fail
    }
  };

  return result;
};
